import { createBrowserRouter, RouteObject } from "react-router-dom";
import { authRoutes } from "./auth-routes";
import { studentRoutes } from "./student-routes";
import { adminRoutes } from "./admin-routes";
import { parentsRoutes } from "./parents-routes";

export const router: ReturnType<typeof createBrowserRouter> =
  createBrowserRouter([
    ...(authRoutes as RouteObject[]),
    ...(studentRoutes as RouteObject[]),
    ...(adminRoutes as RouteObject[]),
    ...(parentsRoutes as RouteObject[]),
  ]);
